// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__Yq18u","placementTop":"styles_placementTop__CqzNo","placementBottom":"styles_placementBottom__7yL09"};